import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Driver } from 'src/app/models/driver';
import { DriverService } from 'src/app/services/driver.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { UtilitiesService } from '../../../../services/utilities.service';

@Component({
  selector: 'app-driver-avatar',
  templateUrl: './driver-avatar.component.html',
  styleUrls: ['./driver-avatar.component.css']
})
export class DriverAvatarComponent implements OnInit {

  @Input() driver:Driver;
  img: string = '';
  actEditDriv:boolean = false;
  @Output() avatarSelectedEvent = new EventEmitter<string>();

  constructor(private driverServ:DriverService,private toastr: ToastrManager,private authService:AuthService, private utl: UtilitiesService) { }

  ngOnInit() {
    this.actEditDriv = this.authService.can("update-driver");

    this.img = environment.baseUrl + '/drivers/' + this.driver.id + '/' + this.driver.avatar;
  }
  
  avatarSelected(event){
    let avatar = event.target.files[0];
    this.driverServ.uploadAvatar(this.driver,avatar).subscribe(driver=>{
      this.driver = driver;
      this.img = environment.baseUrl + '/drivers/' + this.driver.id + '/' + this.driver.avatar;
      this.avatarSelectedEvent.emit('La imagen se ha cargado correctamente');
    },error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

}
